"use client";

import { Link } from "@/i18n/navigation";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Contact from "@/components/Contact/Contact";

const ARTICLE_SLUGS = [
  "vide-maison-bruxelles-guide-complet",
  "combien-coute-vide-maison-bruxelles",
  "vide-maison-gratuit-est-ce-possible",
  "rachat-objets-vide-maison",
  "vide-maison-succession-bruxelles",
  "debarras-appartement-bruxelles-guide",
  "checklist-avant-vide-maison",
  "vide-maison-ixelles-guide",
  "vide-maison-uccle-guide",
  "vide-maison-schaerbeek-guide",
  "vide-maison-anderlecht-guide",
  "duree-debarras-cave-grenier",
  "succession-partager-meubles-heritiers",
  "reconnaitre-objet-valeur-rachat",
  "que-deviennent-meubles-apres-debarras",
];

const CONTENT = {
  fr: {
    heroTitle: "Conseils vide maison à Bruxelles",
    heroSubtitle:
      "Prix, préparation, succession, rachat d'objets de valeur — nos articles pour mieux comprendre le vide maison à Bruxelles.",
    readArticle: "Lire l'article",
    articles: {
      "vide-maison-bruxelles-guide-complet": {
        title: "Vide maison à Bruxelles : le guide complet",
        excerpt: "Tout ce qu'il faut savoir avant de faire vider un bien à Bruxelles : étapes, prix, délais et rachat d'objets.",
      },
      "combien-coute-vide-maison-bruxelles": {
        title: "Combien coûte un vide maison à Bruxelles ?",
        excerpt: "Les facteurs qui influencent le prix, et comment le rachat d'objets peut réduire la facture.",
      },
      "vide-maison-gratuit-est-ce-possible": {
        title: "Vide maison gratuit : est-ce possible ?",
        excerpt: "Dans quels cas un vide maison peut ne rien coûter, voire être rémunéré, grâce au rachat d'objets.",
      },
      "rachat-objets-vide-maison": {
        title: "Rachat d'objets lors d'un vide maison : comment ça marche",
        excerpt: "Le fonctionnement concret du rachat d'objets de valeur, étape par étape.",
      },
      "vide-maison-succession-bruxelles": {
        title: "Vide maison après une succession à Bruxelles",
        excerpt: "Gérer un vide maison dans un contexte de succession : démarches, délais, accompagnement.",
      },
      "debarras-appartement-bruxelles-guide": {
        title: "Débarras d'appartement à Bruxelles : le guide",
        excerpt: "Ce qu'il faut savoir avant de faire débarrasser un appartement, syndic compris.",
      },
      "checklist-avant-vide-maison": {
        title: "Checklist avant un vide maison",
        excerpt: "Les points à vérifier avant l'intervention pour que tout se passe sans stress.",
      },
      "vide-maison-ixelles-guide": {
        title: "Vide maison à Ixelles : ce qu'il faut savoir",
        excerpt: "Spécificités du quartier, kots étudiants, maisons de maître : nos conseils pour Ixelles.",
      },
      "vide-maison-uccle-guide": {
        title: "Vide maison à Uccle : ce qu'il faut savoir",
        excerpt: "Villas et propriétés de standing : nos conseils pour un vide maison réussi à Uccle.",
      },
      "vide-maison-schaerbeek-guide": {
        title: "Vide maison à Schaerbeek : le guide pratique",
        excerpt: "Maisons de maître, quartiers contrastés : nos conseils pour un vide maison à Schaerbeek.",
      },
      "vide-maison-anderlecht-guide": {
        title: "Vide maison à Anderlecht : notre guide pratique",
        excerpt: "Maisons ouvrières, grandes maisons familiales : nos conseils pour un vide maison à Anderlecht.",
      },
      "duree-debarras-cave-grenier": {
        title: "Combien de temps prend un débarras de cave ou grenier ?",
        excerpt: "Les facteurs qui déterminent la durée réelle d'un débarras de cave ou de grenier.",
      },
      "succession-partager-meubles-heritiers": {
        title: "Succession : comment partager les meubles entre héritiers ?",
        excerpt: "Nos conseils pratiques pour organiser le partage des meubles avant un vide maison.",
      },
      "reconnaitre-objet-valeur-rachat": {
        title: "Comment reconnaître un objet qui vaut la peine d'être racheté ?",
        excerpt: "Quelques repères simples pour identifier les objets à faire estimer avant un débarras.",
      },
      "que-deviennent-meubles-apres-debarras": {
        title: "Que deviennent vos meubles après un débarras ?",
        excerpt: "Rachat, réemploi, recyclage : ce qui arrive concrètement aux objets une fois évacués.",
      },
    },
  },
  nl: {
    heroTitle: "Advies over huis leegmaken in Brussel",
    heroSubtitle:
      "Prijs, voorbereiding, nalatenschap, inkoop van waardevolle voorwerpen — onze artikels om het leegmaken van een huis in Brussel beter te begrijpen.",
    readArticle: "Lees het artikel",
    articles: {
      "vide-maison-bruxelles-guide-complet": {
        title: "Huis leegmaken in Brussel: de volledige gids",
        excerpt: "Alles wat u moet weten voordat u een pand in Brussel laat leegmaken: stappen, prijs, termijnen en inkoop van voorwerpen.",
      },
      "combien-coute-vide-maison-bruxelles": {
        title: "Wat kost het leegmaken van een huis in Brussel?",
        excerpt: "De factoren die de prijs beïnvloeden, en hoe de inkoop van voorwerpen de factuur kan verlagen.",
      },
      "vide-maison-gratuit-est-ce-possible": {
        title: "Gratis huis leegmaken: is dat mogelijk?",
        excerpt: "In welke gevallen het leegmaken van een huis niets kost, of zelfs geld kan opleveren, dankzij de inkoop van voorwerpen.",
      },
      "rachat-objets-vide-maison": {
        title: "Inkoop van voorwerpen bij het leegmaken van een huis: hoe werkt het",
        excerpt: "De concrete werking van de inkoop van waardevolle voorwerpen, stap voor stap.",
      },
      "vide-maison-succession-bruxelles": {
        title: "Huis leegmaken na een nalatenschap in Brussel",
        excerpt: "Een huis leegmaken in het kader van een nalatenschap: stappen, termijnen, begeleiding.",
      },
      "debarras-appartement-bruxelles-guide": {
        title: "Appartement ontruimen in Brussel: de gids",
        excerpt: "Wat u moet weten voordat u een appartement laat ontruimen, syndicus inbegrepen.",
      },
      "checklist-avant-vide-maison": {
        title: "Checklist voor het leegmaken van een huis",
        excerpt: "De punten om te controleren vóór de interventie, zodat alles zonder stress verloopt.",
      },
      "vide-maison-ixelles-guide": {
        title: "Huis leegmaken in Elsene: wat u moet weten",
        excerpt: "Specifieke kenmerken van de wijk, studentenkoten, herenhuizen: onze adviezen voor Elsene.",
      },
      "vide-maison-uccle-guide": {
        title: "Huis leegmaken in Ukkel: wat u moet weten",
        excerpt: "Villa's en statige eigendommen: onze adviezen voor een geslaagd huis leegmaken in Ukkel.",
      },
      "vide-maison-schaerbeek-guide": {
        title: "Huis leegmaken in Schaarbeek: de praktische gids",
        excerpt: "Herenhuizen, contrasterende wijken: onze adviezen voor het leegmaken van een huis in Schaarbeek.",
      },
      "vide-maison-anderlecht-guide": {
        title: "Huis leegmaken in Anderlecht: onze praktische gids",
        excerpt: "Arbeiderswoningen, grote gezinswoningen: onze adviezen voor het leegmaken van een huis in Anderlecht.",
      },
      "duree-debarras-cave-grenier": {
        title: "Hoe lang duurt het ontruimen van een kelder of zolder?",
        excerpt: "De factoren die de werkelijke duur van het ontruimen van een kelder of zolder bepalen.",
      },
      "succession-partager-meubles-heritiers": {
        title: "Nalatenschap: hoe verdeelt u meubels tussen erfgenamen?",
        excerpt: "Onze praktische adviezen om de verdeling van meubels te organiseren vóór het leegmaken van een huis.",
      },
      "reconnaitre-objet-valeur-rachat": {
        title: "Hoe herkent u een voorwerp dat het waard is om te worden ingekocht?",
        excerpt: "Enkele eenvoudige aanwijzingen om voorwerpen te identificeren die u vóór een ontruiming moet laten schatten.",
      },
      "que-deviennent-meubles-apres-debarras": {
        title: "Wat gebeurt er met uw meubels na een ontruiming?",
        excerpt: "Inkoop, hergebruik, recyclage: wat er concreet gebeurt met voorwerpen eens ze zijn weggehaald.",
      },
    },
  },
  en: {
    heroTitle: "House Clearance Advice in Brussels",
    heroSubtitle:
      "Price, preparation, inheritance, buyback of valuable items — our articles to help you better understand house clearance in Brussels.",
    readArticle: "Read the article",
    articles: {
      "vide-maison-bruxelles-guide-complet": {
        title: "House clearance in Brussels: the complete guide",
        excerpt: "Everything you need to know before having a property cleared in Brussels: steps, price, timelines and buyback of items.",
      },
      "combien-coute-vide-maison-bruxelles": {
        title: "How much does a house clearance cost in Brussels?",
        excerpt: "The factors that influence the price, and how buying back items can reduce the bill.",
      },
      "vide-maison-gratuit-est-ce-possible": {
        title: "Free house clearance: is it possible?",
        excerpt: "In which cases a house clearance can cost nothing, or even earn you money, thanks to the buyback of items.",
      },
      "rachat-objets-vide-maison": {
        title: "Buying back items during a house clearance: how it works",
        excerpt: "The concrete process of buying back valuable items, step by step.",
      },
      "vide-maison-succession-bruxelles": {
        title: "House clearance after an inheritance in Brussels",
        excerpt: "Managing a house clearance in an inheritance context: steps, timelines, support.",
      },
      "debarras-appartement-bruxelles-guide": {
        title: "Apartment clearance in Brussels: the guide",
        excerpt: "What you need to know before having an apartment cleared, including dealing with the building manager.",
      },
      "checklist-avant-vide-maison": {
        title: "Checklist before a house clearance",
        excerpt: "The points to check before the intervention so everything goes smoothly.",
      },
      "vide-maison-ixelles-guide": {
        title: "House clearance in Ixelles: what you need to know",
        excerpt: "Neighbourhood specifics, student rooms, townhouses: our advice for Ixelles.",
      },
      "vide-maison-uccle-guide": {
        title: "House clearance in Uccle: what you need to know",
        excerpt: "Villas and high-end properties: our advice for a successful house clearance in Uccle.",
      },
      "vide-maison-schaerbeek-guide": {
        title: "House clearance in Schaerbeek: the practical guide",
        excerpt: "Townhouses, contrasting neighbourhoods: our advice for a house clearance in Schaerbeek.",
      },
      "vide-maison-anderlecht-guide": {
        title: "House clearance in Anderlecht: our practical guide",
        excerpt: "Workers' houses, large family homes: our advice for a house clearance in Anderlecht.",
      },
      "duree-debarras-cave-grenier": {
        title: "How long does clearing a cellar or attic take?",
        excerpt: "The factors that determine the actual duration of clearing a cellar or attic.",
      },
      "succession-partager-meubles-heritiers": {
        title: "Inheritance: how to share furniture between heirs?",
        excerpt: "Our practical advice for organising the sharing of furniture before a house clearance.",
      },
      "reconnaitre-objet-valeur-rachat": {
        title: "How to recognise an item worth buying back?",
        excerpt: "A few simple pointers to identify items worth having valued before a clearance.",
      },
      "que-deviennent-meubles-apres-debarras": {
        title: "What happens to your furniture after a clearance?",
        excerpt: "Buyback, reuse, recycling: what actually happens to items once removed.",
      },
    },
  },
};

export default function PageClient({ locale }) {
  const c = CONTENT[locale];

  return (
    <div>
      <section className="relative overflow-hidden bg-sand py-20 text-ink">
        <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(900px 480px at 15% -10%, rgba(27,75,51,0.06), transparent 55%)" }} />
        <div className="relative mx-auto max-w-[1000px] px-6 text-center lg:px-10">
          <h1 className="font-serif text-4xl font-black md:text-5xl">{c.heroTitle}</h1>
          <p className="mx-auto mt-5 max-w-2xl text-ink/65">{c.heroSubtitle}</p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mx-auto max-w-[1000px] px-6 lg:px-10">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            {ARTICLE_SLUGS.map((slug) => {
              const article = c.articles[slug];
              return (
                <Link
                  key={slug}
                  href={`/blog/${slug}`}
                  className="group flex flex-col rounded-3xl border border-sand-line bg-sand p-6 transition hover:-translate-y-1 hover:border-accent hover:bg-white hover:shadow-[0_20px_50px_rgba(28,37,33,0.10)]"
                >
                  <p className="font-serif text-lg font-bold text-ink">{article.title}</p>
                  <p className="mt-2 text-sm leading-relaxed text-neutral-600">{article.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-accent">
                    {c.readArticle}
                    <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <Contact />
    </div>
  );
}
